import request from '@/utils/request'

export function login (data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}
export function getCaptcha (data) {
    return request({
        url: '/returnCaptcha',
        method: 'post',
        data
    })
}

